export default __webpack_public_path__ + "static/media/blue-planet.1ca4573b.svg";